<template>
  <div>
    <menu-top/>


    <v-main>
      <div id="calculadora-itp">
        <section>
          <v-container>
            <v-row justify="center">
              <v-col cols="12" md="10">
                <h1 class="mt-10 mb-3">Calcular el preu de la transferència (ITP)</h1>
                <p class="mb-8 intro-itp">
                  Calcula a l'instant el cost de la transferència d'un cotxe o moto de
                  segona mà: Impost de Transmissions Patrimonials (ITP) més la taxa de la
                  DGT. A Gestoria Riola confirmem el càlcul i tramitem el canvi de
                  titularitat complet per tu.
                </p>

                <calculadora-itp
                  :formspree-endpoint="'https://formspree.io/f/mlgqpqkw'"
                  idioma="cat"
                />
              </v-col>
            </v-row>
          </v-container>
        </section>

        <Footer/>
      </div>
    </v-main>

    <menu-bottom/>
  </div>
</template>

<script>
  import MenuTop from "@/components/MenuTopCat";
  import MenuBottom from "@/components/MenuBottomCat";
  import { mapGetters } from 'vuex';

  import Footer from "@/components/FooterCat";
  import CalculadoraItp from "@/components/CalculadoraItp";

  export default {
    name: 'PageCalculadoraItpCat',
    data: () => ({
    }),
    computed: {
      ...mapGetters(['collapseSidebar']),
    },
    methods: {
    },
    components: {
      Footer,
      MenuTop,
      MenuBottom,
      CalculadoraItp
    }
  }
</script>

<style scoped>
  .intro-itp {
    color: #37454A;
    max-width: 760px;
  }
  #calculadora-itp h1 {
    color: #900A30;
  }
</style>
